import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';

const SiGooglesheets = React.forwardRef(function SiGooglesheets2({ title = "Google Sheets", color = "currentColor", size = 24, ...others }, ref) {
  if (color === "default") {
    color = "#34A853";
  }
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      ref,
      ...others,
      children: [
        /* @__PURE__ */ jsx("title", { children: title }),
        /* @__PURE__ */ jsx("path", { d: "M11.318 12.545H7.91v-1.909h3.41v1.91zM14.728 0v6h6l-6-6zm1.363 10.636h-3.41v1.91h3.41v-1.91zm0 3.273h-3.41v1.91h3.41v-1.91zM20.727 6.5v15.864c0 .904-.732 1.636-1.636 1.636H4.909a1.636 1.636 0 0 1-1.636-1.636V1.636C3.273.732 4.005 0 4.909 0h9.318v6.5h6.5zm-3.273 2.773H6.545v7.909h10.91v-7.91zm-6.136 4.636H7.91v1.91h3.41v-1.91z" })
      ]
    }
  );
});
const SiGooglesheets$1 = SiGooglesheets;

export { SiGooglesheets$1 as default };
